export default {
    "apiUrl": 'https://miu-api.cactusminds.com/admin/',
    "mobileApiUrl": 'https://miu-api.cactusminds.com/',
    "mediaUrl": 'https://miu-api.cactusminds.com',

    // "apiUrl": 'http://localhost:8000/admin/',
    // "mobileApiUrl": 'http://localhost:8000/',
    // "mediaUrl": 'http://localhost:8000',
}